export const memoryFields=['business','role','goal','preferences','next_step'] as const;
export type MemoryField=typeof memoryFields[number];
export type MemoryData=Partial<Record<MemoryField,string>>;
export function parseMemoryData(value:unknown):MemoryData|null{
 if(!value||typeof value!=='object'||Array.isArray(value)||Object.keys(value).some(k=>!memoryFields.includes(k as MemoryField)))return null;
 const data:MemoryData={};
 for(const [k,v] of Object.entries(value)){
  if(typeof v!=='string'||v.length>500)return null;
  if(v.trim())data[k as MemoryField]=v.trim();
 }
 return data;
}
